import { ComponentService } from "../Services/Axios/Api";

class MediaGallery {
    data = {};
    constructor() {
        this.data = {
            id: '',
            ComponentName: 'MediaGallery',
            title: 'Media Gallery',
            images: [],
            isVisible: true,
            mode: 'grid',
            animation: {
                animationType: 'fade-up',
                animationDuration: '800',
                animationDelay: '0'
            }
        };
    }

    // Id   
    getId() { return this.data.id; }
    setId(id) { this.data.id = id; }

    // Name
    getComponentName() { return this.data.ComponentName; }
    setComponentName(ComponentName) { this.data.ComponentName = ComponentName; }

    // Title
    getTitle() { return this.data.title; }
    setTitle(title) { this.data.title = title; }

    // Images
    getImages() { return [...this.data.images]; }
    setImages(images) { this.data.images = [...images]; }
    
    addImage(imageUrl) {
        if (!this.data.images.includes(imageUrl)) {
            this.data.images = [...this.data.images, imageUrl];
        }
    }

    addImages(imageUrls) {
        const uniqueImages = imageUrls.filter(url => !this.data.images.includes(url));
        this.data.images = [...this.data.images, ...uniqueImages];
    }

    removeImage(imageUrl) {
        this.data.images = this.data.images.filter(img => img !== imageUrl);
    }

    removeImageByIndex(index) {
        if (index >= 0 && index < this.data.images.length) {
            this.data.images = this.data.images.filter((_, i) => i !== index);
        }
    }

    // Visibility
    isVisible() { return this.data.isVisible; }
    setVisibility(isVisible) { this.data.isVisible = isVisible; }
    toggleVisibility() { this.data.isVisible = !this.data.isVisible; }

    // Mode
    getMode() { return this.data.mode; }
    setMode(mode) { this.data.mode = mode; }

    // Animation
    getAnimation() { return this.data.animation || { animationType: 'fade-up', animationDuration: '800', animationDelay: '0' }; }
    setAnimation(animation) { this.data.animation = { ...this.getAnimation(), ...animation }; }
    getAnimationType() { return this.getAnimation().animationType; }
    setAnimationType(type) { this.setAnimation({ animationType: type }); }
    getAnimationDuration() { return this.getAnimation().animationDuration; }
    setAnimationDuration(duration) { this.setAnimation({ animationDuration: duration }); }
    getAnimationDelay() { return this.getAnimation().animationDelay; }
    setAnimationDelay(delay) { this.setAnimation({ animationDelay: delay }); }

    // Data
    getData() { return this.data; }
    setData(data) { this.data = data; }

    // Methods
    async load(id) {
        try {
            var response = {};
            var data = {};
            if (id) {
                response = await ComponentService.getComponentById(id);
                data = response.data ? JSON.parse(response.data) : {};
                this.setId(response?.id);
            } else {
                response = await ComponentService.getComponent(this.data.ComponentName);
                data = JSON.parse(response[0]?.data);
                this.setId(response[0]?.id);
            }
            
            if(Object.keys(data).length > 0){
                this.setData(data);
                this.setTitle(data.title);
                this.setImages(data.images);
                this.setMode(data.mode);
                if (data.animation) { this.setAnimation(data.animation); }
            }
            return data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }

    // New method for language-based loading
    async loadByLanguage(language) {
        try {
            const response = await ComponentService.getStaticComponent(this.data.ComponentName, language, true);
            const data = JSON.parse(response?.data);
            
            if(Object.keys(data).length > 0){
                this.setData(data);
                this.setId(response?.id);
                this.setTitle(data.title);
                this.setImages(data.images);
                this.setMode(data.mode);
                if (data.animation) { this.setAnimation(data.animation); }
            }
            return data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }

    async save() {
        try {
            const response = await ComponentService.SaveData(this.getId(), this.getData());
            return response;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
}

export const createMediaGalleryInstance = () => new MediaGallery(); 